import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import RegisterPage from './components/RegisterForm';
import LoginPage from './components/LoginForm';
import Landing from './components/Landing';
import PublicAbout from './components/PublicAbout';
import TermsOfService from './components/TermsOfService';
import Pricing from './components/Pricing';
import Handoff from './components/Handoff';
import ComingSoon from './components/ComingSoon';
import PublicLayout from './components/PublicLayout';
import InvitePage from './components/sharing/InvitePage';
import { LanguageProvider } from './contexts/PublicLanguageContext';
import './App.css';

// IMMEDIATE DEBUG LOG

// Create a simple layout component
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <div className="app-container">
      {children}
    </div>
  );
};

function App() {
  const isAuthenticated = !!localStorage.getItem('token');

  return (
    <Router>
      <LanguageProvider>
        <Routes>
          {/* Public routes with PublicLayout */}
          <Route path="/welcome" element={
            <PublicLayout>
              <Landing />
            </PublicLayout>
          } />
          {/* Spanish and Portuguese live at their own URLs rather than behind
              an Accept-Language swap: Googlebot crawls from US IPs with English
              headers, so a header-only translation is never seen, let
              alone indexed. */}
          <Route path="/es" element={
            <PublicLayout>
              <Landing />
            </PublicLayout>
          } />
          <Route path="/es/about" element={
            <PublicLayout>
              <PublicAbout />
            </PublicLayout>
          } />
          <Route path="/es/pricing" element={
            <PublicLayout>
              <Pricing />
            </PublicLayout>
          } />
          <Route path="/pt" element={
            <PublicLayout>
              <Landing />
            </PublicLayout>
          } />
          <Route path="/pt/about" element={
            <PublicLayout>
              <PublicAbout />
            </PublicLayout>
          } />
          <Route path="/pt/pricing" element={
            <PublicLayout>
              <Pricing />
            </PublicLayout>
          } />
          <Route path="/about" element={
            <PublicLayout>
              <PublicAbout />
            </PublicLayout>
          } />
          <Route path="/terms" element={
            <PublicLayout>
              <TermsOfService />
            </PublicLayout>
          } />
          <Route path="/pricing" element={
            <PublicLayout>
              <Pricing />
            </PublicLayout>
          } />
          <Route path="/coming-soon" element={
            <PublicLayout>
              <ComingSoon />
            </PublicLayout>
          } />
          {/* Silent sign-in handoff from the mobile app */}
          <Route path="/handoff" element={<Handoff />} />

          {/* An invite link has to work signed out: the person it was sent to
              may not have an account yet. The page itself offers sign in and
              sign up, and both come back here. */}
          <Route path="/invite/:token" element={<InvitePage />} />
          <Route path="/register" element={
            <Layout>
              <RegisterPage />
            </Layout>
          } />
          <Route path="/login" element={
            <Layout>
              <LoginPage />
            </Layout>
          } />
          
          {/* Root: the app when logged in, the public landing otherwise.
              Rendering the landing here (instead of redirecting to /welcome)
              means the bare domain is never behind a login — required for
              Google OAuth homepage verification. */}
          <Route path="/" element={
            isAuthenticated ? (
              <Layout>
                <Home />
              </Layout>
            ) : (
              <PublicLayout>
                <Landing />
              </PublicLayout>
            )
          } />
          
          {/* Redirect based on authentication */}
          <Route path="*" element={
            <Navigate to={isAuthenticated ? "/" : "/welcome"} replace />
          } />
        </Routes>
      </LanguageProvider>
    </Router>
  );
}

export default App;